// regex
export const CITY_STATE_HOOD_RE = /^\w[-\w.']+-[a-z]{2}\/[\w.'][-\w.']+$/i
export const CITY_STATE_RE = /^\w[-\w.']+-[a-z]{2}$/i
export const DETAIL_RE = /(?:a|b|p)?\d+/
export const NEAR_UNIVERSITY_RE = /\/near(.*)(college|university)(.*)+-[a-z]{2}/
export const STATE_RE = /^[a-z]{2}$/i
export {
  /** @deprecated `import { FILTERS_START_RE } from '@zcode/nr-utils'` instead */
  FILTERS_START_RE,
} from '@zcode/nr-utils'
export const PROPERTY_TYPE_PATH_RE = /(?:apartments|condos|houses|rooms)-for-rent/
export const DIGITS_RE = /^[0-9]+$/
// end of regex
